export default {
  'en-US': {
    whenToStartShippingOptions: {
      Now: 'I\'m already shipping product',
      LessThanSixWeeks: 'Within 6 weeks',
      MoreThanSixWeeks: 'More than 6 weeks',
      NotSure: 'I\'m not sure yet - just browsing'
    }
  }
}
